import CookieConsent from 'react-cookie-consent';

import './styles.css';

function CustomCookieConsent() {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: '100vw',
      }}
    >
      <CookieConsent
        location="bottom"
        buttonText="Aceitar políticas"
        cookieName="PrivacyPolicyAccepted"
        containerClasses="container-style"
        buttonClasses="button-style"
        contentClasses="content-style"
        expires={150}
        overlay
        onAccept={async () => {}}
      >
        Utilizamos cookies essenciais e tecnologias semelhantes de acordo com a
        nossa{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.cliqueretire.com.br/politica-de-cookie/"
        >
          Política de Privacidade
        </a>{' '}
        e, ao continuar navegando, você concorda com estas condições.
      </CookieConsent>
    </div>
  );
}

export default CustomCookieConsent;
